import { render, staticRenderFns } from "./text-row-addresses.vue?vue&type=template&id=5d048c80&scoped=true&"
import script from "./text-row-addresses.vue?vue&type=script&lang=js&"
export * from "./text-row-addresses.vue?vue&type=script&lang=js&"
import style0 from "./text-row-addresses.vue?vue&type=style&index=0&id=5d048c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d048c80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d048c80')) {
      api.createRecord('5d048c80', component.options)
    } else {
      api.reload('5d048c80', component.options)
    }
    module.hot.accept("./text-row-addresses.vue?vue&type=template&id=5d048c80&scoped=true&", function () {
      api.rerender('5d048c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-addresses.vue"
export default component.exports